'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _extends =
  Object.assign ||
  function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i]
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key]
        }
      }
    }
    return target
  }

var _templateObject = _taggedTemplateLiteral(
  [
    '\n  display: block;\n\n  a {\n    color: ',
    ';\n    text-decoration: underline;\n  }\n'
  ],
  [
    '\n  display: block;\n\n  a {\n    color: ',
    ';\n    text-decoration: underline;\n  }\n'
  ]
)

var _Text = require('./Text')

var _Text2 = _interopRequireDefault(_Text)

var _styledSystem = require('styled-system')

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var Label = _Text2.default
  .withComponent('label')
  .extend(_templateObject, function(props) {
    return props.theme.colors.info
  })

Label.displayName = 'Label'

Label.propTypes = _extends({}, _styledSystem.propTypes.width)

Label.defaultProps = {
  theme: _theme2.default,
  color: 'black',
  f: 2,
  w: 1
}

exports.default = Label



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Label.js
// module id = 123
// module chunks = 168707334958949